:root {
    --color-primary: var(--white);
    --color-text: var(--black);
    --color-contrast: var(--red);
}

.themed {
    background-color: var(--color-primary);
    color: var(--color-text);
}

// themes with red
@each $c
    in (
        "white",
        "orange",
        "salmon",
        "lilac",
        "yellow",
        "pink",
        "melon",
        "light-orange",
        "light-poppy",
        "light-green",
        "light-lilac",
        "light-yellow",
        "mid-gray",
        "light-gray",
        "neutral"
    )
{
    .#{$c} {
        composes: themed;

        --color-primary: var(--#{$c});
        --color-text: var(--black);
        --color-contrast: var(--red);
    }
}

// themes with white
@each $c
    in (
        "black",
        "red",
        "burgundy",
        "emerald",
        "navy",
        "vine",
        "poppy",
        "dark-gray"
    )
{
    .#{$c} {
        composes: themed;

        --color-primary: var(--#{$c});
        --color-text: var(--white);
        --color-contrast: var(--white);
    }
}

// all black themes
@each $c in ("tomato", "rose") {
    .#{$c} {
        composes: themed;

        --color-primary: var(--#{$c});
        --color-text: var(--black);
        --color-contrast: var(--black);
    }
}
